import { Nav, INavStyles, INavLinkGroup, INavLink } from "@fluentui/react";
import React from "react";
import {
  _initialFilter,
  _initialPagination,
  _onRenderHeader,
} from "../../../../utils/helpers/helpers";
import { Outlet, useNavigate } from "react-router-dom";
import COLORES from "../../../../utils/theme/colores";

const VistaDispositivos: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const outletStyle: Object = {
    maxHeight: "calc(100vh - 3rem)",
    overflowY: "hidden",
    width: "100%",
  };
  const navStyles: Partial<INavStyles> = {
    root: {
      width: "200px",
      height: "calc(100vh - 3rem)",
      boxSizing: "border-box",
      overflowY: "auto",
      borderRight: "0.5px solid #c8c6c4",
      cursor: "pointer",
      backgroundColor: "#faf9f8",
    },
    groupContent: {
      marginBottom: "15px",
      padding: "0 10px 0 0",
    },
    link: {
      paddingLeft: "25px",
      height: "28px",
      font: "inherit",
      borderBottom: "0.3px solid #c8c6c4",
      margin: 5,
    },
    chevronButton: {
      fontSize: "14px",
      height: "35px",
      borderRadius: "10xp",
    },
  };
  const _clickNavigate = (
    ev?: React.MouseEvent<HTMLElement>,
    item?: INavLink
  ) => {
    if (ev) {
      ev.preventDefault();
      if (item) {
        navigate(item.url);
      }
    }
  };
  const navLinkGroups: INavLinkGroup[] = [
    {
      name: "Dispositivos",
      links: [
        {
          key: "historial",
          name: "Histórico",
          url: "detalle/historico",
          icon: "EntitlementRedemption",
        },
        {
          key: "asignados",
          name: "Asignados",
          url: "detalle/asignados",
          icon: "Group",
        },
        {
          key: "dispositivos",
          name: "Dispositivos",
          url: "detalle/dispositivos",
          icon: "TabletMode",
        },
      ],
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            maxHeight: "calc(100vh - 3rem)",
          }}
        >
          <div>
            <Nav
              styles={navStyles}
              groups={navLinkGroups}
              onLinkClick={_clickNavigate}
            />
          </div>
          <div style={outletStyle}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default VistaDispositivos;

export interface IFormAsignacion {
  dispositivoId?: string;
  personaId?: string;
  sesionIdEntrega?: string;
}
